module.exports = __webpack_public_path__ + "static/img/yhlogo2.1bc49f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yhlogo2.jpg
// module id = GllK
// module chunks = 40